import ErrorAlert from "@/utility/ErrorAlert";
import http from "../axios/http-common";

async function create(data) {
  const response = await http
    .postData("/asesmen-awal-ranap-keperawatan", data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response;
}

async function update(id, data) {
  const response = await http
    .putData(`/asesmen-awal-ranap-keperawatan/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response;
}

async function getByRegister(register_id: string | number) {
  const response = await http
    .getData(`/register/${register_id}/asesmen-awal-ranap-keperawatan`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response;
}

async function find(id: number) {
  const response = await http
    .getData(`/asesmen-awal-ranap-keperawatan/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response;
}

async function destroy(id: number) {
  const response = await http
    .deleteData(`/asesmen-awal-ranap-keperawatan/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response;
}

async function verifyDpjp(id: number, dpjpUserId: number) {
  const response = await http
    .postData(`/asesmen-awal-ranap-keperawatan/${id}/verify-dpjp`, {
      dpjp_user_id: dpjpUserId
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response;
}

async function verifyPpja(id: number, ppjaUserId: number) {
  const response = await http
    .postData(`/asesmen-awal-ranap-keperawatan/${id}/verify-ppja`, {
      ppja_user_id: ppjaUserId
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response;
}

function print(id) {
  window.open(
    `${http.getAPI()}/asesmen-awal-ranap-keperawatan/${id}/pdf`,
    "_blank"
  );
}

export default {
  create,
  update,
  getByRegister,
  find,
  destroy,
  verifyDpjp,
  verifyPpja,
  print
};
